import { autocomplete } from './autocomplete'
import { timeStamp } from './utilities'

export default function search (document, moduleHTML, appEventEmitter, autocompleteService) {
  const autocompleteEl = moduleHTML.querySelector('[data-js-autocomplete]')
  const fields = ['place_id', 'formatted_address']
  autocomplete({ inputEl: autocompleteEl, onAutocompleteSelect, fields })

  function onAutocompleteSelect (place) {
    if (place && place.formatted_address) {
      // Remove trailing country as this sometimes returns the wrong lat/long from geocoding (e.g. Canton, GA)
      const formattedPlace = place.formatted_address.replace(', USA', '')
      autocompleteEl.value = formattedPlace
      gaTrackZip(autocompleteEl.value)
      moduleHTML.submit()
    }
  }

  moduleHTML.addEventListener('submit', (event) => {
    // Emulate downarrow + enter when clicking search or hitting enter
    // so that the first autocomplete option is selected and then the
    // onAutocompleteSelect logic is triggered.
    event.preventDefault()
    const pressDown = new KeyboardEvent('keydown', {
      key: 'ArrowDown',
      code: 'ArrowDown',
      keyCode: 40
    })
    const pressEnter = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13
    })
    autocompleteEl.dispatchEvent(pressDown)
    autocompleteEl.dispatchEvent(pressEnter)
  })

  function gaTrackZip (searchValue) {
    if (!(window && window.dataLayer)) return

    window.dataLayer.push({
      event: 'zip-search',
      zipSearchQuery: searchValue,
      customEventCategory: 'ZipSearch',
      customEventAction: searchValue,
      customEventLabel: `${timeStamp()}~${window.location}`
    })
  }
}
